import { forwardRef, useState, useRef, useEffect, useImperativeHandle } from 'react';

import 'react-datepicker/dist/react-datepicker.css';
import { Autocomplete } from '@mui/material';
import { isEqual } from 'lodash';
import { FS } from "@plannel/utils/font-util";

import "@plannel/scss/components/GridAutoComplete.scss";

const GridAutoComplete = forwardRef((props, ref) => {
  const { column } = props;
  const { actualWidth, colDef } = column;
  const { values, equalProperty, labelProperty = "name" } = colDef.cellEditorParams;

  const refAutoComplete = useRef();
  const refAutoCompleteInput = useRef(null);

  const [value, setValue] = useState(props?.value);
  const [editing, setEditing] = useState(true);
  const [selected, setSelected] = useState(true);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return value;
      },

      // isCancelBeforeStart() {
      //   return false;
      // },

      // isCancelAfterEnd() {
      //   // our editor will reject any value greater than 1000
      //   return value;
      // }
    }
  });

  const onChange = (_, newValue, reason) => {
    if (!isEqual(reason, "clear")) {
      setValue(newValue);
      if (props.onValueChange) {
        props.onValueChange(newValue);
      }

      setSelected(false);
      setEditing(false);
    }
  };

  useEffect(() => {
    const eInput = refAutoComplete.current;
    eInput.focus();

  }, []);


  useEffect(() => {
    if (!editing) {
      props.api.stopEditing();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editing]);

  return (
    <Autocomplete
      className='grid-autocomplete-input'
      tabIndex={1}
      ref={refAutoComplete}
      options={values}
      getOptionLabel={option => option[labelProperty]}
      value={value}
      onChange={onChange}
      open={selected}
      isOptionEqualToValue={(option, value) => option[equalProperty] === value[equalProperty]}
      size="small"
      disablePortal
      classes={{ paper: "grid-autocomplete grid-autocomplete-paper", listbox: "grid-autocomplete grid-autocomplete-listbox" }}
      renderInput={(params) => {
        return (
          <div ref={params.InputProps.ref} style={{ width: actualWidth }}>
            <input ref={refAutoCompleteInput} type="text" {...params.inputProps} style={{ fontSize: FS.SUB, width: actualWidth }} />
          </div>
        )
      }}
    />
  );
});

export default GridAutoComplete;
